module.exports = __webpack_public_path__ + "static/img/left3.ac8d7a14.png";